// extracted by mini-css-extract-plugin
export var container = "_fy-0";
export var content = "_fy-3";
export var customerTitle = "_fy-4";
export var empty = "_fy-5";
export var gray = "_fy-6";
export var header = "_fy-7";
export var info = "_fy-8";
export var loading = "_fy-2";
export var loadingCard = "_fy-9";
export var oneLine = "_fy-a";
export var personName = "_fy-e";
export var pillContainer = "_fy-b";
export var selected = "_fy-1";
export var text = "_fy-c";
export var twoLines = "_fy-d";
export var unread = "_fy-f";
export var unreadIndicator = "_fy-g";